export const routes = {
    //common routes
    auth_response: "/authresp",
    accept_terms: "/accept-terms",
    base_url: "/",
    login_url: "/login",

    test: '/test',
    //assessment routes
    view_assessment: "/assessments-library",
    view_assessment_pass_info: ({ isPublic }) => ({
        state: {
            isPublic: isPublic
        }
    }),
    finalize: "/finalize",
    setup_assessment: "/setup-assessment",
    student_view: "/student-view",
    grade: "/grade",
    grade_report: "/grade-report",
    teacher_grade_report: "/teacher-grade-report",
    settings_view: "/assessment-settings",
    search_question: "/question-statistics",
    view_assessment_review: "/assessment-review",

    //new assess ques routes
    view_assessment: "/assessments-library",
    asses_lib: "/asses-lib",
    ques_lib: "/ques-lib",
    ppr_rew: "/ppr-rew",
    mng_ppr: "/mng-ppr",
    exm: "/exm",
    asses_lib_add: "/asses-lib/add",
    asses_lib_view: "/asses-lib/view/:id",
    asses_lib_edit: "/asses-lib/edit/:id",
    asses_lib_setup: "/asses-lib/setup/:id",
    asses_lib_setup_part_edit: "/asses-lib/setup/:id/part/:partId/edit",
    asses_lib_setup_section_edit:
        "/asses-lib/setup/:id/part/:partId/section/:sectionId/edit",
    asses_lib_setup_question_view:
        "/asses-lib/setup/:id/question/:questionId/view",
    asses_lib_student_view: "/asses-lib/setup/:id/student-view",
    asses_lib_setup_add_questions: "/asses-lib/setup/:id/add-questions",
    ques_lib_create_with_assessment: "/ques-lib/create-with-assessment",
    ques_lib_create: "/ques-lib/create",
    ques_lib_view: "/ques-lib/view/:id",
    ques_lib_edit: "/ques-lib/edit/:id",
    ppr_rew_view: "/ppr-rew/view/:id",
    ppr_rew_edit_question: "/ppr-rew/view/:paperId/edit-question/:questionId",
    mng_ppr_view: "/mng-ppr/view/:id",
    exm_grade_report: "/exm/grade-report/:id",
    exm_self_grading: "/exm/self-grading/:id",
    exm_result_sheet: "/exm/result-sheet/:id",
    exm_consent: "/exm/consent/:id/:mode",
    exm_paper: "/exm/paper/:id/:mode",

    //question routes
    questions_library: "/questions-library",
    new_question: "/new-question",
    create_question: "/create-question",
    create_add_to_assessment: "/create-question-add-to-assessment",
    edit_question: "/edit-question",
    finalize_new_question: "/finalize-new-question",

    //manage routes
    admin_url: "/ESadmin",
    teacher_url: "/Educator",
    sign_in_url: "/sign-in",
    profile: "/profile",

    manage_teacher: "/manage-teacher",
    manage_student: "/manage-student",
    manage_cgc_student: "/manage-cgc-student",
    manage_admin: "/manage-admin",
    manage_parent: "/manage-parent",

    manage_invitations: "/manage-invitations",
    manage_dashboard: "/manage-dashboard",
    manage_enrollment: "/manage-enrollment",
    manage_teacher_enrollment: "/manage-teacher-enrollment",
    manage_attendance: "/manage-attendance",
    manage_about: "/manage-about",
    manage_organization_attribute: "/manage-organization-attribute",
    manage_search: "/manage-search",
    calendar_app: "/calendar-app",
    main_calendar: "/main-calendar",
    feedback_form: "/feedback-form",

    paper_list: "/paper-list",
    paper_mapping: "/paper-mapping",
    paper_mapping_view: "/paper-mapping/details/:assessmentId",

    form_attachment: "/form-attachment",
    manage_form: "/manage-form",
    manage_node: "/manage-node",
    user_list: "/user-list",

    manage_documents: "/manage-documents",
    manage_marksheet: "/manage-marksheet",
    manage_announcement: "/manage_announcement",
    announcements: "/announcements",
    announcements_new: "/announcements-new",

    payment_gateway: "/payment-gateway",
    manage_payment: "/manage-payment",
    manage_subscription_main: "/manage-subscription-main",

    // cart route
    my_cart: "/my-cart",
    cart_summary: "/cart-summary",
    buy_cart_summary: "/buy-cart-summary",
    saved_items: "/saved-items",
    cart_summary_view: "/cart-summary-view",
    my_accounts: "/my-accounts",
    my_account_orders: "/my-account/orders",
    my_account_invoices: "/my-account/invoices",
    account_management: "/account-management",
    admin_order_management_orders: "/order-sales-management/orders",
    admin_order_management_invoices: "/order-sales-management/invoices",
    credit_fee_currency_types: "/credit-fee-management/currency-types",
    credit_fee_credit_price: "/credit-fee-management/credit-price",
    credit_fee_purchase_methods: "/credit-fee-management/purchase-methods",
    credit_fee_credit_categories: "/credit-fee-management/credit-categories",
    credit_fee_exam_fees: "/credit-fee-management/exam-credit-fees",
    credit_fee_credit_package: "/credit-fee-management/credit-package",
    credit_fee_package_credit_price: "/credit-fee-management/package-credit-price",
    admin_user_package_subscriptions: "/manage/user-package-subscriptions",
    admin_user_assessment_purchasings: "/manage/user-assessment-purchasings",
    settings_config_system_settings: "/settings-configurations/system-settings",
    settings_config_application_configurations: "/settings-configurations/application-configurations",
    settings_config_max_credit_limit: "/settings-configurations/application-settings/max-credit-limit",

    quiz_mapping: "/quiz-mapping",
    manage_settings: "/manage-settings",
    manage_sitemap: "/manage-sitemap",
    manage_chat: "/manage-chat",
    manage_progress: "/manage-progress",
    user_reports: "/user-reports",

    register_student: "/register-student",
    my_requests: "/my-requests",
    search_papers: "/search-papers",
    parent_student_signup: "/parent-student-signup",
    registration_form_view: "/register",
    terms_and_conditions_view_from_registration_form: "/terms-and-conditions",
    terms_and_conditions_view: "/conditions",
    payment_terms_condition: "/payment-term",
    available_exams: "/available-exams",
    my_exams: "/my-exams",
    find_papers: "/available-exams",

    //candidate routes
    enrolled_paper_list: "/enrolled-paper-list",
    paper_details: "/exam-details",
    self_grade: "/self-grade",
    paper_grade_report: "/exam-grade-report",
    paper_auto_grade_report: "/exam-auto-grade-report",
    view_question_paper: "/view-exam-questions",
    paper_review: "/exam-review",
    subscriptions: "/subscriptions",
    assess_subscriptions: "/assess-subscriptions",

    assessment_template: "/assessment-template",
    question_passage: "/question-passage"
}
